/* ONAM routes inside MAP. The flow starts on MAP's entry hub (restyled), then Engage › Advertising. */
import type { SourceId } from "./data";

export type Section = "marketplace" | "studio" | "history" | "connectors";
export const ONAM_PATHS = {
  root: "/onam",
  sources: "/onam/advertising",
  workspace: (src: SourceId) => `/onam/advertising/${src}`,
  section: (s: Section, src: SourceId = "dnpa") => `/onam/advertising/${src}/${s}`,
  /** MAP's entry hub and its consoles */
  home: "/entry-hub",
  engageHub: "/entry-hub?console=Engage",
};
export const SECTIONS: [Section, string, string][] = [
  ["marketplace", "Audience Marketplace", "orbit"],
  ["studio", "Audience Studio", "sliders"],
  ["history", "Campaign history", "activity"],
  ["connectors", "Activation connectors", "external"],
];

/** Routes that wear the ONAM header and footer instead of MAP's: the way in and ONAM itself. Curation keeps MAP's chrome. */
export const isOnamChrome = (pathname: string) => {
  const p = pathname.toLowerCase();
  return p === "/home" || p === "/entry-hub" || p.startsWith("/onam");
};
